import styled from 'styled-components'

const NavBox = styled.div`
  width: 100%;
  border-bottom: 1px solid #c5c5c5;
`
export const NavHeader = styled(NavBox)`
  display: block;
  padding: 10px;
`

export const NavFooter = styled(NavBox)`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50px;
`

export const NavBody = styled.ul`
  overflow-y: auto;
  padding-left: 0;
  list-style: none;
  margin: 0;
  display: flex;
  height: 100%;
  max-height: calc(100vh - 50px - 45px);
  flex-direction: column;
`

const Name = styled.span`
  display: block;
  width: 100%;
  text-align: center;
`

export const NameOrder = styled(Name)`
  font-size: 16px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const NameProject = styled(Name)`
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
`

export const Sidebar = styled.aside`
  position: absolute;
  top: 0;
  left: ${props => (props.isClosed ? `-${props.theme.sidebar.width}` : '0')};
  width: ${props => props.theme.sidebar.width};
  height: ${props => props.theme.sidebar.height};
  background-color: ${props => props.theme.sidebar.backgroundColor};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;

  transition: .40s ease-in-out;
`

export const CloseButton = styled.button`
  position: absolute;
  top: calc(50% - 30px);
  right: -20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 60px;
  background: ${props => props.theme.sidebar.backgroundColor};
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 6px 0 10px -2px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 9999;
  border: none;
  padding: 0;
`

export const SaveButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
  text-align: center;

  background: none;
  border: none;
  outline: none;

  transition: all 0.25s ease-in-out;

  & > i,
  & > svg {
    font-size: 20px;
    margin-right: 20px;
    color: ${props => props.theme.colors.alternativeHover};
    transition: all 0.25s ease-in-out;
  }

  &:hover {
    background-color: ${props => props.theme.colors.alternativeHover};
    color: #f7f7f7;
    cursor: pointer;
    & > i,
    & > svg {
      color: #f7f7f7;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Sidebar/theme.js